module.exports = __webpack_public_path__ + "static/media/mic_on.153ceac8.svg";